import Icon from '../components/Icon.vue'

Icon.register({
  'layer-group': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M12.4 148c-16.5-7.5-16.5-32.5 0-40l232.9-105.7c2.8-1.3 7.6-2.3 10.6-2.3s7.8 1 10.6 2.3l232.9 105.7c16.5 7.5 16.5 32.5 0 40l-232.9 105.7c-6.8 3.1-14.5 3.1-21.3 0zM499.6 236.3c16.5 7.5 16.5 32.5 0 40l-232.9 105.6c-6.8 3.1-14.5 3.1-21.3 0l-232.9-105.6c-16.5-7.5-16.5-32.5 0-40l58.1-26.3 161.6 73.3c7.6 3.4 15.6 5.2 23.9 5.2s16.3-1.7 23.9-5.2l161.6-73.3zM499.6 364.1c16.5 7.5 16.5 32.5 0 40l-232.9 105.6c-6.8 3.1-14.5 3.1-21.3 0l-232.9-105.6c-16.5-7.5-16.5-32.5 0-40l57.9-26.2 161.8 73.4c7.6 3.4 15.6 5.2 23.9 5.2s16.3-1.7 23.9-5.2l161.9-73.4z'
      }
    ]
  }
})
